import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Menu, Dropdown, Icon } from 'antd';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import ReactHichart from 'react-highcharts';
import { ContentSection } from '~/components';
import ContentData from '~/hoc/ContentData';
import { WaterStorageAction } from '~/actions';
import { DivMargin15, H2Title } from '~/containers/styles';
import moment from '~/_moment';

const MenuItem = Menu.Item;

class WaterStorage extends Component {
  static propTypes = {
    damProfile: PropTypes.object,
  };

  static defaultProps = {
    damProfile: {
      site_name: '...',
      pressure: {
        waterStorage: {
          upperLine: [],
          lowerLine: [],
        },
      },
    },
  };

  state = {
    year: 2018,
  };

  UNSAFE_componentWillMount() {
    this.getDataWaterStorage(this.props);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const requestYear = Number(nextProps.match.params.year) || this.now;

    if (this.state.year !== requestYear) {
      this.getDataWaterStorage(nextProps);
    }
  }

  getDataWaterStorage = (props) => {
    const {
      damProfile: { firstRun },
      getWaterStorage,
      match: {
        params: { year: yearParam },
      },
    } = props;

    const firstRunYear = Number(moment(firstRun, 'YYYY-MM-DD').format('Y'));

    this.now = Number(moment().format('Y'));
    let year = Number(yearParam || this.now) || this.now;

    if (year < firstRunYear) {
      year = firstRunYear;
    } else if (year > this.now) {
      year = this.now;
    }

    this.setState({ year }, () => {
      getWaterStorage(year);
    });
  };

  getConfig = () => {
    const {
      damProfile: {
        site_name: siteName,
        pressure: {
          waterStorage: { upperLine, lowerLine },
        },
      },
      waterStorage: { history },
    } = this.props;

    return {
      title: {
        text: `ข้อมูลปริมาณการกักเก็บน้ำในอ่าง ปี ${this.state.year}`,
      },
      subtitle: {
        text: siteName,
      },
      yAxis: {
        title: {
          text: 'ปริมาณกาารกักเก็บ (ล้าน ลบ.ม.)',
        },
      },
      xAxis: {
        type: 'datetime',
      },
      series: [
        {
          name: 'Upper line',
          data: this.convertTimeIndex(upperLine),
        },
        {
          name: 'Current line',
          data: history.reduce((result, rec) => {
            result.push([rec.unix * 1000, rec.value]);
            return result;
          }, []),
        },
        {
          name: 'Lower line',
          data: this.convertTimeIndex(lowerLine),
        },
      ],
    };
  };

  getMenu = () => {
    const {
      damProfile: { firstRun },
    } = this.props;

    const firstRunYear = Number(moment(firstRun, 'YYYY-MM-DD').format('Y'));

    const menuList = [];

    for (let i = firstRunYear; i <= this.now; i += 1) {
      menuList.push(
        <MenuItem key={i}>
          <Link to={`/water/storage/${i}`}>{i}</Link>
        </MenuItem>,
      );
    }

    return menuList;
  };

  convertTimeIndex = (line) => {
    const {
      waterStorage: { startTime },
    } = this.props;
    const startTimeMilisec = startTime * 1000;
    return line.reduce((result, val, i) => {
      result.push([startTimeMilisec + i * 86400000, val]);
      return result;
    }, []);
  };

  render() {
    const {
      damProfile: { site_name: siteName },
    } = this.props;

    const { year } = this.state;

    const menu = <Menu>{this.getMenu()}</Menu>;

    return (
      <ContentSection>
        <Helmet>
          <title>ข้อมูลปริมาณการกักเก็บน้ำ</title>
        </Helmet>

        <ContentData isLoading={false} title={`กำลังเตรียมข้อมูลปริมาณการกักเก็บน้ำใน ${siteName}`}>
          <DivMargin15>
            <div className="col-12 text-center">
              <H2Title>{`ข้อมูลปริมาณการกักเก็บน้ำใน ${siteName}`}</H2Title>
              <p className="text-center">
                กำลังแสดงข้อมูลของปี&nbsp;
                <Dropdown overlay={menu}>
                  <a
                    className="ant-dropdown-link"
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                    }}
                  >
                    {year} <Icon type="down" />
                  </a>
                </Dropdown>
              </p>
            </div>
          </DivMargin15>

          <DivMargin15>
            <ReactHichart config={this.getConfig()} />
          </DivMargin15>
        </ContentData>
      </ContentSection>
    );
  }
}

export default connect(
  (state) => ({
    damProfile: state.DamProfile,
    waterStorage: state.WaterStorage,
  }),
  {
    getWaterStorage: WaterStorageAction.getWaterStorage,
  },
)(WaterStorage);



// WEBPACK FOOTER //
// ./resources/assets/js/containers/WaterStorage/index.js